import { ComponentSlotStylesPrepared, ICSSInJSStyle } from '@fluentui/styles';

import { ToolbarMenuRadioGroupWrapperProps } from '../../../../components/Toolbar/ToolbarMenuRadioGroupWrapper';
import { ToolbarVariables } from './toolbarVariables';

export const toolbarMenuRadioGroupWrapperStyles: ComponentSlotStylesPrepared<
  ToolbarMenuRadioGroupWrapperProps,
  ToolbarVariables
> = {
  root: (): ICSSInJSStyle => ({}),
};
